module.exports = __webpack_public_path__ + "img/shopline.2b0c3b96.png";